module.exports = __webpack_public_path__ + "static/media/logo_dark.661b8097.png";